/* ************ Utils ************ */

function getConfiguration() {
    return {
        currency: 'USD',
        analyticsEnabled: true,
        writeLogsEnabled: false,
        pdpOfferEnabled: true,
        offerModalEnabled: true,
        cartOfferEnabled: true,
        sideCartOfferEnabled: true,
        cartBalancingEnabled: true,
        aftermarketModalEnabled: true,
        atcOfferEnabled: true,
        quickviewOfferEnabled: true,
        quickviewModalOfferEnabled: true,
        cartSPEnabled: false
    };
}

function verifyExtend() {
    const propertiesToCheck = [
        'window.Extend',
        'window.ExtendShopify',
        'window.Shopify',
        'window.Shopify.currency.active'
    ];
    
    function checkPropertyExists(path) {
        return path.split('.').reduce((obj, prop) => obj && obj[prop], window) !== undefined;
    }
    
    let errors = propertiesToCheck.filter(prop => !checkPropertyExists(prop));
    
    // Check for currency mismatch
    if (window.Shopify?.currency?.active !== getConfiguration().currency) {
        errors.push('window.Shopify.currency.active == config.currency');
    }
    
    if (errors.length) {
        let message = "The following value(s) are null, undefined, or false:\n";
        errors.forEach((error) => {
            message += `\t${error}\n`;
        });
        throw new ExtendError(message);
    }
}

class ExtendError extends Error {
    constructor(message) {
        super("EXTEND: " + message);
    }
}

function initAftermarket() {
    try {
        verifyExtend();

        // Get params from URL
        const params = (new URL(document.location)).searchParams;

        // Check if leadToken or leadtoken is in the URL
        let leadToken = params.get('leadToken')
            ? params.get('leadToken')
            : params.get('leadtoken');

        if (leadToken) {
            Extend.aftermarketModal.open({
                leadToken: leadToken,
                onClose: function (plan, product, quantity) {
                    if (plan && product) {
                        ExtendShopify.addPlanToCart({
                            plan: plan,
                            product: product,
                            leadToken: leadToken,
                            quantity: quantity || 1
                        }, function () {
                            location = '/cart'
                        })
                    }
                }
            });
        }
    } catch (error) {
        throw new ExtendError( error.message);
    }
}

/* ************ Analytics ************ */

// getPlanId - Takes in the cart and a product ID and returns the plan ID for that product
function getPlanProduct(cart, productId) {
    return cart.items.filter((item) => productId == item.properties['_Extend.ProductId'])[0];
}

function productAnalytics(productId, productQuantity = 1) {
    if (productId) {
        Extend.trackProductAddedToCart({ productId, productQuantity });
    } else {
        console.warn("Extend: Product id is " + productId)
    }
}

function cartAnalytics(oldCart, newCart) {
    try {
        //if there is an old or new cart with items. 
        if (oldCart && newCart && oldCart.items && newCart.items) { 
            // Triggers if an item has been removed
            if (oldCart.items.length > newCart.items.length) {

                oldCart.items.forEach((oldCartItem) => {
                    let matchedItems = newCart.items.filter((newCartItem) => oldCartItem.id == newCartItem.id);

                    if (!matchedItems.length) {
                        if (oldCartItem.properties['__Extend.IsExtendWarranty']) {
                            Extend.trackOfferRemovedFromCart({ productId: oldCartItem.properties['_Extend.ProductId'], planId: oldCartItem.properties['_Extend.PlanId']});
                        } else if (oldCartItem.id) {
                            Exetnd.trackProductRemovedFromCart({ productId: oldCartItem.id });
                        }
                    }
                });

                // Triggers if an item quantity has changed
            } else if (oldCart.item_count != newCart.item_count) {
                oldCart.items.forEach((oldCartItem) => {

                    // Get non-Extend updated items
                    if (oldCartItem.vendor == 'Extend') return;
                    
                    let newCartItem = newCart.items.filter((newCartItem) => oldCartItem.id == newCartItem.id && oldCartItem.quantity != newCartItem.quantity)[0];

                    if (ExtendShopify.warrantyAlreadyInCart(oldCartItem.id, oldCart.items)) {
                        let attachedPlan = getPlanProduct(newCart, oldCartItem.id);
                        Extend.trackOfferUpdated({
                            productId: oldCartItem.id,
                            updates: {
                                warrantyQuantity: attachedPlan.quantity,
                                productQuantity: newCartItem.quantity
                            }
                        })
                    } else {
                        Extend.trackProductUpdated({
                            productId: oldCartItem.id,
                            updates: {
                                productQuantity: newCartItem.quantity
                            }
                        })
                    }
                });
            }
        } else {
            console.warn("EXTEND: corrupt cart objects");
        }
    } catch(error) {
        console.error("EXTEND: " + error);
    }
}

/* ************ Product Offers ************ */

class ExtendProduct extends HTMLElement {
    constructor(productForm, addToCartButton) {
        super();

        const referenceId = productForm.id.value;
        const price = meta.product.variants.filter(variant => variant.id == referenceId)[0].price;
        const category = meta.product.type;

        this.offerParams = {
            referenceId,
            price,
            category
        }
        
        this.config = getConfiguration();
        this.config.dispatchSideCart = false;
        
        this.productForm = productForm,
        this.addToCartButton = addToCartButton;
        this.quantityEl = this.productForm.querySelector('input[name="quantity"]');
    }
    
    connectedCallback() {
        try {
            this.verifyProductOffer();
        } catch (err) {
            console.error(err.message);
            return;
        }
     
        this.bindEvents();
        
        if (!this.config.pdpOfferEnabled) this.style.display = 'none';
        // Renders Extend offer
        Extend.buttons.render(this, this.offerParams);
    }
    
    bindEvents() {
        this.handleAddToCart = this.handleAddToCart.bind(this);
        this.addToCartButton.addEventListener('click', this.handleAddToCart, true);
        // this.productForm.addEventListener('submit', this.handleAddToCart.bind(this), true);
        
        this.productForm.addEventListener('change', this.handleVariantChange.bind(this), true);
    }
    
    verifyProductOffer() {

        let elementsToCheck = [
            'this.productForm',
            'this.addToCartButton',
            'this.offerParams.referenceId',
            'this.offerParams.price'
//            'this.offerParams.category'
        ]
        
        let missingElements = elementsToCheck.filter((value) => {
            try {
                return !eval(value);
            } catch (err) {
                return true;
            }
        });
        
        if (missingElements.length) {
            let message = "The following value(s) are null or undefined:\n";
            missingElements.forEach((value) => {
                message += `\t${value}\n`;
            });
            throw new ExtendError(message);
        }
        
        // Checks if Extend lives in the window and the active currency is USD before showing Extend offers
        verifyExtend();
        
    }
    
    /**
    * Handle add to cart event with offers
    * @param {PointerEvent} e Click event from Add To Cart Button
    */
    handleAddToCart(e, callback) {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        const quantity = this.quantityEl && this.quantityEl.value ? this.quantityEl.value : 1;
        
        ExtendShopify.handleAddToCart(this, {
            quantity,
            modal: this.config.modalOfferEnabled,
            done: typeof callback == 'function' ? callback : this.handleAddToCartDone.bind(this) 
        });
    }

    handleAddToCartDone() {
        // Trigger Analytics
        if (this.config.analyticsEnabled) productAnalytics(this.offerParams.referenceId, this.quantityEl.value);

        // // remove default click listener
        this.addToCartButton.removeEventListener('click', this.handleAddToCart, true);
        // this.productForm.removeEventListener('submit', this.handleAddToCart);

        // // click atc button
        this.addToCartButton.click();
        // // add default click listener back
        this.addToCartButton.addEventListener('click', this.handleAddToCart, true);
        // this.productForm.addEventListener('submit', this.handleAddToCart, true)
    }
    
    handleVariantChange() {
        // Flicker prevention
        this.style.height = `${this.clientHeight}px`;

        this.offerParams.referenceId = this.productForm.id.value;
        this.offerParams.price = meta.product.variants.filter(variant => variant.id == this.offerParams.referenceId)[0].price;
        
        
        Extend.setActiveProduct(this, this.offerParams);
    }
}
customElements.define('extend-offer', ExtendProduct);

/**
* Initializes product offers and handles ATC button functionality for the main PDP ATC
*/
function initProductOffer() {
    if (meta.page.pageType != 'product' || !meta.product) return;

    const productFormSelector = '[data-product-form]';
    const addToCartButtonSelector = '[data-product-atc]';

    const productForm = document.querySelector(productFormSelector);
    const addToCartButton = productForm ? productForm.querySelector(addToCartButtonSelector) : document.querySelector(addToCartButtonSelector);
    
    // Create offer and render it
    const extendOffer = new ExtendProduct(productForm, addToCartButton);
    addToCartButton.before(extendOffer);
}

/* ************ Cart Offers ************ */
const offerTagName = 'extend-cart-offer';

const {
    cartOfferEnabled,
    cartSPEnabled,
    sideCartOfferEnabled,
    cartBalancingEnabled,
    analyticsEnabled
} = getConfiguration();

let selectors;
let type;
if (window.location.pathname.includes('cart')) {
    selectors = {
        cartContainerSelector: '[data-cart-item-list]', // Cart container
        cartRowItem: '[data-cartitem]', // Container element for each item in the cart
        cartRowItemImage: '.cart-item--image-wrapper a', // Product image or image anchor element
        cartRowItemTitle: '.cart-item--content-title a', // Title anchor element for the product
        cartRowItemQuantity: '.input[name="updates[]"]', // Input element containing the product quantity
        warrantyOriginalMeta: 'dl', // Each warranty metadata item we want to remove.
        offerContainer: '.cart-item--content', // Container where the offer will be appended
        metadataContainer: '.cart-item-product-options', // Where warranty metadata will be appended (Product and Term)
        quantityWrapper: '.quantity-selector__wrapper' // Wrapper for quantity input and buttons
    };
    type = 'main';
    
} else {
    selectors = {
        cartContainerSelector: 'cart-form.cart-drawer', // Cart container
        cartRowItem: '[data-merge-list="cart-items"] [data-merge-list-item]', // Container element for each item in the cart
        cartRowItemImage: '.cart-item__image', // Product image or image anchor element
        cartRowItemTitle: '.cart-item__title a', // Title anchor element for the product
        cartRowItemQuantity: '.cart-item__quantity-input', // Input element containing the product quantity
        warrantyOriginalMeta: '.line-item-property,.cart-item__variant', // Each warranty metadata item we want to remove.
        offerContainer: '.cart-item__description', // Container where the offer will be appended
        metadataContainer: '.cart-item__description .small-text', // Where warranty metadata will be appended (Product and Term)
        quantityWrapper: '.quantity' // Wrapper for quantity input and buttons
    }
    type = 'side';
}

let cart;

class ExtendCartOffer extends HTMLElement {
    constructor(referenceId, quantity, price, category) {
        super();

        this.params = {
            referenceId,
            quantity,
            price,
            category
        }
    }

    connectedCallback() {
        Extend.buttons.renderSimpleOffer(this, {
            referenceId: this.params.referenceId,
            price: this.params.price,
            category: this.params.category,
            onAddToCart: ({ plan, product }) => {
                ExtendShopify.addPlanToCart({
                    plan,
                    product,
                    quantity: this.params.quantity
                }, (err) => {
                    if (err) {
                        throw new ExtendError(err.message);
                    }
                    refreshCartMarkup();
                })
            }
        })
    }
}
customElements.define(offerTagName, ExtendCartOffer);

function createElement(lineItemElement, index) {
    const cartItem = cart.items[index];

    const referenceId = cartItem.id;
    const quantity = cartItem.quantity;
    const price = cartItem.price;
    const category = cartItem.product_type;
    const warrantyAlreadyInCart = ExtendShopify.warrantyAlreadyInCart(referenceId.toString(), cart.items) || ExtendShopify.warrantyAlreadyInCart(referenceId, cart.items);

    if (type == 'side' && !sideCartOfferEnabled) return;
    if (type == 'main' && !cartOfferEnabled) return;
    
    // Parent container to append cart offer
    let container = lineItemElement.querySelector(selectors.offerContainer);
            
    if (!container) {
        throw new ExtendError(`Offer container unavailable on line item ${index + 1}`);
    }
    
    // If an offer exists, remove it if the quantity or reference ID do not match
    let extendOffer = lineItemElement.querySelector(offerTagName);
    if (extendOffer) {
        if (extendOffer.params.extendReferenceId !== referenceId ||
            extendOffer.params.extendQuantity !== quantity ||
            extendOffer.params.extendPrice !== price ||
            extendOffer.params.extendCategory !== category ||
            warrantyAlreadyInCart) {

            extendOffer.remove();
        } else {
            return;
        }
    }

    if (warrantyAlreadyInCart) return;

    extendOffer = new ExtendCartOffer(referenceId, quantity, price, category);
    container.append(extendOffer);
}

function styleCart() {
    let container = document.querySelector(selectors.cartContainerSelector);
        
    if (!container) {
        throw new ExtendError(`Invalid cart container selector ${cartContainerSelector}`);
    }
    
    container.querySelectorAll(selectors.cartRowItem).forEach((lineItemElement, index) => {
        let title = lineItemElement.querySelector(selectors.cartRowItemTitle);
        
        if (!title) {
            throw new ExtendError('Line item title not found');
        }

        let lowerCaseTitle = title.textContent.toLowerCase();
        
        if (lowerCaseTitle.indexOf('extend protection') > -1) {
            // Select and remove pointerEvents from warranty title
            title.style.pointerEvents = 'none';
            
            let image = lineItemElement.querySelector(selectors.cartRowItemImage);
            
            if (!image) {
                throw new ExtendError(`Image unavailable for line item ${title.innerText}`);
            }
            
            // Select and remove pointerEvents from warranty image
            image.style.pointerEvents = 'none';
            
            
            /**************************************/
            /* THEME SPECIFIC STYLING START       */
            /**************************************/
            // Removes old metadata

            if (lineItemElement.querySelector(selectors.warrantyOriginalMeta)) {
                lineItemElement.querySelectorAll(selectors.warrantyOriginalMeta).forEach((each) => {
                    each.remove();
                })
            }
            
            if (selectors.quantityWrapper?.length && lineItemElement.querySelector(selectors.quantityWrapper) && type == 'main') {
                lineItemElement.querySelectorAll(selectors.quantityWrapper).forEach((each) => {
                    each.style.opacity = '75%';
                    each.style.pointerEvents = 'none';
                })
            }
            
            // Selects where to append warranty metadata
            let contentContainer = lineItemElement.querySelector(selectors.metadataContainer)
            let warrantyProductData;
            let warrantyTermData;
            let cartItem = cart.items[index];
            
            if (cartItem.options_with_values && cartItem.options_with_values[1]) { // Finds the ref id string in the product info string and replaces with an empty string
                let regexReplace = cartItem.options_with_values[0].value.match(/\-\d{5,}/g);
                warrantyProductData = cartItem.options_with_values[0].value.replace(regexReplace, '');
                warrantyTermData = cartItem.options_with_values[1].value;
            } else {
                warrantyProductData = cartItem.properties.Product;
                warrantyTermData = cartItem.properties.Term;
            }
            
            // For category offers, fetch title by filtering through cart for warranted product refId
            if (warrantyProductData === "Covered Product") {
                const coveredProductId = cartItem.properties['_Extend.ProductId'];
                warrantyProductData = cart.items.find((item) => item.id.toString() == coveredProductId).title;
            }
            
            // Appends Product and Term metadata
            if (lineItemElement.querySelector(selectors.metadataContainer)) {
                let warrantyProductName = document.createElement('dl');
                warrantyProductName.className = 'extend-warranty-info extend-warranty-info-product cart-item-product-options__option tpo_cart-properties-wrapper';
                warrantyProductName.innerHTML = `<dt class="cart-item-product-options__option-key">Product:</dt><dd class="cart-item-product-options__option-value">${warrantyProductData}</dd>`;
                
                let warrantyProductTerm = document.createElement('dl')
                warrantyProductTerm.className = 'extend-warranty-info extend-warranty-info-term cart-item-product-options__option tpo_cart-properties-wrapper';
                warrantyProductTerm.innerHTML = `<dt class="cart-item-product-options__option-key">Term:</dt><dd class="cart-item-product-options__option-value">${warrantyTermData}</dd>`;
                
                // Only append the metadata if it's not already there
                if (!lineItemElement.querySelector('.extend-warranty-info')) {
                    contentContainer.append(warrantyProductName, warrantyProductTerm)
                }
            }
            
            /**************************************/
            /* THEME SPECIFIC STYLING END         */
            /**************************************/
        } else if (lowerCaseTitle.indexOf('extend shipping') > -1) {
            lineItemElement.style.display = 'none';
        } else {
            createElement(lineItemElement, index);
        }
    });
}

async function getCart() {
    let cartResponse = await fetch('/cart.js&sections=static-cart', {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    });
    return await cartResponse.json();
}

function refreshCartMarkup() {
    debugger;
    window.location.reload();
}

function initCartOffer() {
    verifyExtend();
    if (!window.location.pathname.includes('cart')) return;

    ExtendShopify.normalizeCart({
        balance: cartBalancingEnabled
        }, (err, data) => {
            if (err) {
                throw new ExtendError(err);
            }

            cart = data.cart
            if (data?.updates) {
                refreshCartMarkup(data.cart);
            }
            styleCart();

        }
    );
}

document.addEventListener('extend.refreshCartOffer', () => {
    setTimeout(initCartOffer, 500);
});

// Integration init

(() => {
    try {
        const storeId = 'e853bc63-0d83-45c0-ac6e-964d6fd1ab18';
        const environment = 'production';

        window.Extend.config({ storeId, environment});

        const config = getConfiguration();

        if (config.aftermarketModalEnabled)
            initAftermarket();

        if (config.atcOfferEnabled || config.offerModalEnabled || config.pdpOfferEnabled)
            initProductOffer();

        if (config.cartOfferEnabled || config.cartSPEnabled || config.sideCartOfferEnabled)
            initCartOffer();
    } catch (err) {
        if (sessionStorage.getItem('extend.debug'))
            console.error(err);
    }
})();